var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotFoundDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 480 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 175,
    r: 174.545,
    fill: "#475467"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.727,
    cy: 44.091,
    r: 17.454,
    fill: "#1D2939"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 275.364,
    r: 13.091,
    fill: "#1D2939"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.545,
    cy: 301.545,
    r: 21.818,
    fill: "#1D2939"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.182,
    cy: 100.818,
    r: 21.818,
    fill: "#1D2939"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.727,
    cy: 24.454,
    r: 15.273,
    fill: "#1D2939"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#not-found-dark_svg__filter0_dd_10338_9778)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.605 35.364c-36.515 0-68.816 18.044-88.473 45.701a87.019 87.019 0 00-19.994-2.314c-47.924 0-86.774 38.85-86.774 86.774s38.85 86.774 86.774 86.774h216.935c41.933 0 75.927-33.994 75.927-75.928 0-41.933-33.994-75.927-75.927-75.927-2.979 0-5.917.172-8.806.505-16.622-38.578-54.988-65.585-99.662-65.585z",
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.138,
    cy: 165.525,
    r: 86.774,
    fill: "url(#not-found-dark_svg__paint0_linear_10338_9778)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.605,
    cy: 143.831,
    r: 108.468,
    fill: "url(#not-found-dark_svg__paint1_linear_10338_9778)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.072,
    cy: 176.371,
    r: 75.927,
    fill: "url(#not-found-dark_svg__paint2_linear_10338_9778)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#not-found-dark_svg__filter1_b_10338_9778)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.909,
    y: 183.727,
    width: 122.182,
    height: 122.182,
    rx: 61.091,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.909 267.727l-11.073-11.072m5.982-14.382c0 11.246-9.117 20.363-20.364 20.363-11.246 0-20.363-9.117-20.363-20.363 0-11.247 9.117-20.364 20.363-20.364 11.247 0 20.364 9.117 20.364 20.364z",
    stroke: "#F2F4F7",
    strokeWidth: 5.091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-found-dark_svg__paint0_linear_10338_9778",
    x1: 72.508,
    y1: 108.192,
    x2: 225.912,
    y2: 252.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-found-dark_svg__paint1_linear_10338_9778",
    x1: 164.318,
    y1: 72.165,
    x2: 356.073,
    y2: 252.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "not-found-dark_svg__paint2_linear_10338_9778",
    x1: 297.771,
    y1: 126.205,
    x2: 432,
    y2: 252.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "not-found-dark_svg__filter0_dd_10338_9778",
    x: 32.364,
    y: 35.364,
    width: 419.636,
    height: 256.935,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_10338_9778"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10338_9778"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    "in": "SourceAlpha",
    result: "effect2_dropShadow_10338_9778"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_10338_9778",
    result: "effect2_dropShadow_10338_9778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_10338_9778",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "not-found-dark_svg__filter1_b_10338_9778",
    x: 170.909,
    y: 175.727,
    width: 138.182,
    height: 138.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10338_9778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_10338_9778",
    result: "shape"
  })))));
}

export default SvgNotFoundDark;